import { Bold } from "../../Bold/Bold";
import { Italic } from "../../Italic/Italic";
import { Underline } from "../../Underline/Underline";

interface TextDecorationContentProps {
    textBoxId: string;
}

export const TextDecorationContent = ({ textBoxId }: TextDecorationContentProps) => {
    return (
        <div className="absolute top-full translate-y-2 bg-white dark:bg-darkSurface-200 py-6 rounded-xl shadow-[0px_4px_50px_rgba(0,0,0,0.08)] flex gap-4 px-6">
            <div className="border border-irGray-300 dark:border-darkSurface-400 rounded-md">
                <Bold textBoxId={textBoxId} />
            </div>
            <div className="border border-irGray-300 dark:border-darkSurface-400 rounded-md">
                <Italic textBoxId={textBoxId} />
            </div>
            <div className="border border-irGray-300 dark:border-darkSurface-400 rounded-md">
                <Underline textBoxId={textBoxId} />
            </div>
        </div>
    );
};
